// components/JobRow.jsx
import { jobService } from "../routes/services/AutoGenerateImage/jobService";
import { useNavigate } from "react-router-dom";

export default function JobRow({ job, onReload }) {
  const badgeMap = {
    PENDING: "secondary",
    RUNNING: "primary",
    SUCCESS: "success",
    FAILED: "danger",
    CANCELLED: "dark"
  };
  const navigate = useNavigate();

  return (
    <tr>
      <td>
        <div className="fw-semibold">{job.name}</div>
        <small className="text-muted">{job.lastMessage}</small>
      </td>

      <td>{job.type}</td>

      <td>
        <span className={`badge bg-${badgeMap[job.status]}`}>
          {job.status}
        </span>
      </td>

      <td>
        <div className="progress" style={{ height: 6 }}>
          <div
            className="progress-bar"
            style={{ width: `${job.progress}%` }}
          />
        </div>
        <small className="text-muted">{job.progress}%</small>
      </td>

      <td className="text-end">
        {job.status === "RUNNING" && (
          <button
            className="btn btn-sm btn-outline-danger me-2"
            onClick={async () => {
              await jobService.cancelJob(job.id);
              onReload();
            }}
          >
            Cancel
          </button>
        )}

        {job.status === "FAILED" && (
          <button
            className="btn btn-sm btn-outline-warning me-2"
            onClick={async () => {
              await jobService.retryJob(job.id);
              onReload();
            }}
          >
            Retry
          </button>
        )}

        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => navigate(`/genimage/job/${job.id}`)}
        >
          Detail
        </button>
      </td>
    </tr>
  );
}
